export default __webpack_public_path__ + "static/media/mg.623e9243.webp";